export default "__VITE_ASSET__d_te$YA4__"